import type { AriaRole } from 'react';
import React from '../../../lib/teact/teact';

import type { ColorIconName, IconName } from '../../../types/icons';

import buildClassName from '../../../util/buildClassName';

const COLOR_ICON_PATTERN = /-(?:red|blue|green|orange|yellow|cyan|indigo|purple|pink|amber|teal|gray|silver)(?:-\d+)?$/;

const isColorIcon = (name: IconName): name is ColorIconName => COLOR_ICON_PATTERN.test(name);

type OwnProps = {
  name: IconName;
  className?: string;
  style?: string;
  role?: AriaRole;
  ariaLabel?: string;
  character?: string;
  ref?: RefObject<HTMLElement | undefined>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: (e: React.MouseEvent<any>) => void;
};

const Icon = ({
  name,
  ref,
  className,
  style,
  role,
  ariaLabel,
  character,
  onClick,
}: OwnProps) => {
  if (isColorIcon(name)) {
    return (
      <svg
        ref={ref as RefObject<SVGSVGElement | undefined>}
        className={buildClassName('icon', className)}
        width="1em"
        height="1em"
        style={style}
        aria-hidden={!ariaLabel}
        aria-label={ariaLabel}
        role={role}
        onClick={onClick}
      >
        <use href={`#${name}`} />
      </svg>
    );
  }

  return (
    <i
      ref={ref}
      className={buildClassName(`icon icon-${name}`, className)}
      style={style}
      aria-hidden={!ariaLabel}
      aria-label={ariaLabel}
      data-char={character}
      role={role}
      onClick={onClick}
    />
  );
};

export default Icon;
